const package_name_showcase = 'showcase';
const package_name_fastlane = 'fastlane';
export const promotionCart = {
    elementToSetContent: 'promotionBuyCart',
    add(promotion) {
        let adId = $('#idOrRgisterNumber').val();
        if (this.validate(promotion, adId)) {
            let pars = `promotion=${promotion}&adId=${adId}&id_fastlane=${$('#promoFastlaneId').val()}&id_showcase_package=${$('#id_showcase_package').val()}`;
            this.sendRequest(Routing.generate('promotion_add'), pars);
        }
    },
    remove(promotion, adId) {
        this.sendRequest(Routing.generate('promotion_remove'), `adId=${adId}&promotion=${promotion}`);
    },
    sendRequest(url, params) {
        $.post(url, params, function (data) {
            $(`#${promotionCart.elementToSetContent}`).html(data);
            if ($('.shoppingCartLayout').length) {
                $('.cartButtonForSmallLayout').show();
            } else {
                $('.cartButtonForSmallLayout').hide();
            }
        });
    },
    isNumeric(value) {
        return value.match(/[1-9]/);
    },
    validate(promotion, adId) {
        let $errorMessageFastlane = $('#errorMessageFastlane');
        let $errorMessageShowcase = $('#errorMessageShowcase');
        if (promotion === package_name_fastlane) {
            $errorMessageFastlane.text('');
            if (!this.isNumeric(adId)) {
                $errorMessageFastlane.text(Translations.promotion_purchase.select_ad);
                return false;
            }

            if (!this.isNumeric($('#promoFastlaneId').val())) {
                $errorMessageFastlane.text(Translations.promotion_purchase.select_fastlane);
                return false;
            }

            return true;
        }
        if (promotion === package_name_showcase) {
            $errorMessageShowcase.text('');
            if (!this.isNumeric(adId)) {
                $errorMessageShowcase.text(Translations.promotion_purchase.select_ad);
                return false;
            }

            if (!this.isNumeric($('#id_showcase_package').val())) {
                $errorMessageShowcase.text(Translations.promotion_purchase.select_showcase);
                return false;
            }

            return true;
        }

        return false;
    },
};

$(function () {
    $('.scrollToShoppingCart').click(function () {
        $('html,body').animate({ scrollTop: $('.shoppingCartLayout').offset().top }, 300);
    });

    $('#idOrRgisterNumber').keyup(function () {
        let idOrRgisterNumber = $(this).val().trim();
        if (idOrRgisterNumber.length > 4) {
            const searchByIdToken = $('#app').data('csrf-search-by-id');
            $.post(
                Routing.generate('search_by_id'),
                {
                    ad_id: idOrRgisterNumber,
                    token: searchByIdToken,
                },
                function (data) {
                    if (data.success) {
                        $('#qs_srch_result').addClass('result_img_right').removeClass('result_img_wrong');
                        $('.qsIdRegMessage').hide();
                        $('.qsIdRegMessageTitle').show().text(data.title);
                    } else {
                        $('#qs_srch_result').addClass('result_img_wrong').removeClass('result_img_right');
                        $('.qsIdRegMessage').show();
                        $('.qsIdRegMessageTitle').hide().html();
                        if (data.message) {
                            alert(data.message);
                        }
                    }
                }
            );
        } else {
            $('#qs_srch_result').addClass('result_img_wrong').removeClass('result_img_right');
            $('.qsIdRegMessage,.qsIdRegMessageTitle').hide();
        }
    });

    $('.addToFastlane').click(function () {
        promotionCart.add(package_name_fastlane);
    });

    $('.addToShowcase').click(function () {
        promotionCart.add(package_name_showcase);
    });

    $('body').on('click', '.removeFromPromotion', function () {
        promotionCart.remove($(this).data('promotion-name'), $(this).data('promotion-id'));
    });

    $('.promotionBuyTooltip').tooltip({
        items: '[data-title]',
        classes: {
            'ui-tooltip': 'ui-tooltip promotionalCart',
        },
        content() {
            return $(this).data('title');
        },
        position: {
            my: 'left+5 top-130',
        },
        show: { effect: 'fade', delay: 1000 },
        close(_event, ui) {
            ui.tooltip.hover(
                function () {
                    $(this).stop(true).fadeTo(1000, 1);
                },
                function () {
                    $(this).fadeOut(1000, function () {
                        $(this).remove();
                    });
                }
            );
        },
    });
});
